import React, { useState } from "react"
import Logo from "./logo"
import NavDrawer from "./navDrawer"
import { Dropdown } from "react-bootstrap"
import { Link, navigate } from "gatsby"
import { connect } from "react-redux"
import { logout } from "../state/actions/auth"
import Avatar from "./avatar"
import AddProfilePicture from "./addProfilePicture"

// Styles
import styles from "../styles/components/header.module.scss"

const Header = ({ logout, isLoggedIn, isAdmin, profile }) => {
  // Modal
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  return (
    <div id="top">
      <header className={styles.header}>
        <ul className={styles.navbar}>
          <Link
            to={isAdmin ? "/admin" : isLoggedIn ? "/app/dashboard" : "/"}
            className={styles.logo}
          >
            <Logo />
          </Link>

          <div className={styles.navdrawer}>
            <NavDrawer />
          </div>

          <div className={styles.links}>
            <li>
              {isLoggedIn ? (
                <>
                  {isAdmin && (
                    <Link
                      to="/admin"
                      activeClassName={styles.active}
                      partiallyActive={true}
                    >
                      Admin Panel
                    </Link>
                  )}

                  <Link
                    to="/app/dashboard"
                    activeClassName={styles.active}
                    partiallyActive={true}
                  >
                    Dashboard
                  </Link>
                  <Link to="/app/workout" activeClassName={styles.active}>
                    Workout
                  </Link>
                  <Link to="/app/meal" activeClassName={styles.active}>
                    Meal Plan
                  </Link>

                  <Link to="/app/progress" activeClassName={styles.active}>
                    Progress
                  </Link>
                  <div>
                    <Dropdown>
                      <Dropdown.Toggle variant="">
                        <Avatar
                          image={
                            (profile && profile.image && profile.image.url) ||
                            undefined
                          }
                          variant="xs"
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className={styles.menu}>
                        {isAdmin && (
                          <Dropdown.Item
                            onClick={() => {
                              navigate("/admin/")
                            }}
                          >
                            Admin Panel
                          </Dropdown.Item>
                        )}
                        <Dropdown.Item
                          onClick={() => {
                            navigate("/app/dashboard/edit-profile/")
                          }}
                        >
                          Edit Profile
                        </Dropdown.Item>
                        <Dropdown.Item onClick={handleShow}>
                          Change Profile Picture
                          <AddProfilePicture show={show} close={handleClose} />
                        </Dropdown.Item>

                        <Dropdown.Item onClick={logout} className="text-danger">
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </>
              ) : (
                <>
                  <Link to="/" activeClassName={styles.active}>
                    Home
                  </Link>

                  <Link to="/app" activeClassName={styles.active}>
                    <div className={styles.loginBtn}>Login</div>
                  </Link>
                </>
              )}
            </li>
          </div>
        </ul>
      </header>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    isLoggedIn: state.isLoggedIn,
    isAdmin: state.isAdmin,
    profile: state.profile,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
